(function () {
    'use strict';

    const TEAM_MANAGER_ORIGIN = 'https://edge-team-manager.netlify.app';
    const BASE_PLAN_SLUG = 'default-product';

    function getGroupSize(tier) {
        const source = `${tier?.slug || ''} ${tier?.name || ''}`;
        const match = source.match(/x\s*(\d+)|custom[-_\s]?(\d+)/i);

        if (!match) return null;

        const size = Number(match[1] || match[2]);
        return size >= 5 && size <= 20 ? size : null;
    }

    function getSelectedPeriod() {
        return document.querySelector('.toggle-option.active[data-period]')?.dataset.period === 'yearly'
            ? 'yearly'
            : 'monthly';
    }

    function getTierPrice(tier, period) {
        if (!tier) return null;

        const rawValue = period === 'yearly'
            ? tier.yearly_price
            : tier.monthly_price;

        const value = Number(rawValue);
        return Number.isFinite(value) ? value / 100 : null;
    }

    function formatCurrency(amount, currency) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }

    function getIndividualTier(tiers) {
        const cardSlug = document.querySelector('.flip-card.plan-dark[data-tier-slug]')?.dataset.tierSlug;

        return tiers.find(tier => tier.slug === cardSlug)
            || tiers.find(tier => tier.slug === BASE_PLAN_SLUG)
            || tiers.find(tier => !getGroupSize(tier) && getTierPrice(tier, 'monthly') !== null)
            || null;
    }

    function initialiseGroupPricing() {
        const groupSection = document.getElementById('group-plans');
        const slider = document.getElementById('teamSlider');

        if (!groupSection || !slider) return;

        groupSection.classList.add('edge-group-selector');

        const pricingInfo = groupSection.querySelector('.group-pricing-info');
        const totalPrice = groupSection.querySelector('.total-price');
        const perUserPrice = groupSection.querySelector('.per-user-price');
        const discount = groupSection.querySelector('.discount');
        const currentPrice = groupSection.querySelector('.current-price');
        const priceDifference = groupSection.querySelector('.price-diff');

        pricingInfo?.setAttribute('aria-live', 'polite');

        if (totalPrice && !totalPrice.textContent.trim()) {
            totalPrice.textContent = 'Select a team size to view pricing.';
        }

        function renderPricing() {
            const tiers = Array.isArray(window.allTiers) ? window.allTiers : [];
            const size = Number(slider.value);
            const period = getSelectedPeriod();
            const periodLabel = period === 'yearly' ? '/year' : '/month';

            const groupTier = tiers.find(tier => getGroupSize(tier) === size);
            const individualTier = getIndividualTier(tiers);
            const selectedTotal = getTierPrice(groupTier, period);
            const individualPrice = getTierPrice(individualTier, period);

            if (!groupTier || selectedTotal === null) {
                if (totalPrice) {
                    totalPrice.textContent = tiers.length
                        ? `No Ghost tier was found for a ${size}-user plan.`
                        : 'Pricing is temporarily unavailable. Please refresh the page.';
                }

                if (perUserPrice) perUserPrice.textContent = '';
                if (discount) discount.textContent = '';
                return;
            }

            const currency = groupTier.currency || individualTier?.currency || 'USD';

            if (totalPrice) {
                totalPrice.textContent = `Total: ${formatCurrency(selectedTotal, currency)}${periodLabel}`;
            }

            if (perUserPrice) {
                perUserPrice.textContent = `Per user: ${formatCurrency(selectedTotal / size, currency)}${periodLabel}`;
            }

            if (discount) {
                if (individualPrice !== null) {
                    const standardCost = individualPrice * size;
                    const savings = standardCost - selectedTotal;
                    const savingsPercent = standardCost > 0
                        ? Math.round((savings / standardCost) * 100)
                        : 0;

                    discount.textContent = savings > 0
                        ? `Group saving: ${formatCurrency(savings, currency)}${periodLabel} (${savingsPercent}%)`
                        : '';
                } else {
                    discount.textContent = '';
                }
            }

            if (currentPrice) {
                const currentSlug = window.currentMemberTierSlug || '';
                const currentTier = tiers.find(tier => tier.slug === currentSlug);
                const currentPeriod = window.currentMemberBillingPeriod === 'year'
                    ? 'yearly'
                    : 'monthly';
                const currentAmount = getTierPrice(currentTier, currentPeriod);

                if (window.currentMemberStatus === 'comped') {
                    currentPrice.textContent = 'Current plan: Complimentary';
                } else if (currentAmount !== null) {
                    const currentCurrency = currentTier?.currency || currency;
                    const currentPeriodLabel = currentPeriod === 'yearly' ? '/year' : '/month';
                    currentPrice.textContent = `Current catalogue price: ${formatCurrency(currentAmount, currentCurrency)}${currentPeriodLabel}`;
                }
            }

            if (priceDifference) {
                const currentSlug = window.currentMemberTierSlug || '';
                const currentTier = tiers.find(tier => tier.slug === currentSlug);
                const currentPeriod = window.currentMemberBillingPeriod === 'year'
                    ? 'yearly'
                    : 'monthly';
                const currentAmount = getTierPrice(currentTier, currentPeriod);

                if (currentAmount !== null && currentPeriod === period) {
                    const difference = selectedTotal - currentAmount;
                    priceDifference.textContent = difference === 0
                        ? 'No catalogue-price difference.'
                        : `Catalogue-price difference: ${difference > 0 ? '+' : '−'}${formatCurrency(Math.abs(difference), currency)}${periodLabel}`;
                } else if (currentSlug && currentPeriod !== period) {
                    priceDifference.textContent = 'The billing frequency will also change. Ghost and Stripe calculate the final prorated amount.';
                } else {
                    priceDifference.textContent = '';
                }
            }
        }

        slider.addEventListener('input', renderPricing);

        document.querySelectorAll('.toggle-option[data-period]').forEach(toggle => {
            toggle.addEventListener('click', function () {
                window.setTimeout(renderPricing, 0);
            });
        });

        document.getElementById('teamMinus')?.addEventListener('click', function () {
            window.setTimeout(renderPricing, 0);
        });

        document.getElementById('teamPlus')?.addEventListener('click', function () {
            window.setTimeout(renderPricing, 0);
        });

        renderPricing();
    }

    function initialiseEmbeddedTeamManager() {
        const shell = document.getElementById('team-manager-shell');
        const frame = document.getElementById('team-manager-frame');
        const teamAccordion = document.getElementById('manage-team-accordion');

        if (!shell || !frame) return;

        frame.classList.add('edge-team-manager-embed');

        function buildEmbeddedUrl() {
            const rawUrl = shell.dataset.appUrl;
            if (!rawUrl) return null;

            try {
                const url = new URL(rawUrl);
                url.searchParams.set('embed', '1');

                const email = shell.dataset.email || '';
                if (email) url.searchParams.set('email', email);

                return url;
            } catch (error) {
                console.error('Unable to create the embedded Team Manager URL:', error);
                return null;
            }
        }

        function ensureEmbeddedFrameUrl() {
            const currentSource = frame.getAttribute('src');
            if (!currentSource) return;

            try {
                const url = new URL(currentSource, window.location.href);
                if (url.origin !== TEAM_MANAGER_ORIGIN || url.searchParams.get('embed') === '1') return;

                url.searchParams.set('embed', '1');
                frame.src = url.toString();
            } catch (error) {
                console.error('Unable to update the Team Manager iframe URL:', error);
            }
        }

        const frameObserver = new MutationObserver(ensureEmbeddedFrameUrl);
        frameObserver.observe(frame, {
            attributes: true,
            attributeFilter: ['src']
        });

        teamAccordion?.querySelector('.accordion-header')?.addEventListener('click', function () {
            if (frame.getAttribute('src')) return;

            const url = buildEmbeddedUrl();
            if (url) frame.src = url.toString();
        }, true);

        window.addEventListener('message', function (event) {
            if (event.origin !== TEAM_MANAGER_ORIGIN || event.source !== frame.contentWindow) return;
            if (event.data?.type !== 'edge-team-manager-height') return;

            const requestedHeight = Number(event.data.height);
            if (!Number.isFinite(requestedHeight)) return;

            const height = Math.min(1600, Math.max(340, Math.ceil(requestedHeight) + 4));
            frame.style.setProperty('height', `${height}px`, 'important');
            frame.style.setProperty('min-height', `${height}px`, 'important');
        });

        ensureEmbeddedFrameUrl();
    }

    function initialise() {
        initialiseGroupPricing();
        initialiseEmbeddedTeamManager();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialise);
    } else {
        initialise();
    }
})();
